import ModalDeleteFilled from '../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteCustomerBillingGroupProps extends ModalEditComponentProps { }

const ModalDeleteCustomerBillingGroup: React.FC<ModalDeleteCustomerBillingGroupProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/customerBillingGroup/deleteBillingGroupCustomer',
        data: {
            BillingGroupId: allRowData?.BillingGroupId,
            CustomerId: allRowData?.CustomerId,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteBillingGroupCustomer', '¿Seguro quieres eliminar este grupo de facturación de este cliente?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteCustomerBillingGroup